import React, { useEffect, useState } from "react";
import axios from "axios";
import Gateway from "./Gateway";

export const Sitesettings = () => {
  // --- STATES (UNCHANGED) ---
  const [WebTitle, setWebTitle] = useState("");
  const [WebsiteName, setWebName] = useState("");
  const [CompanyName, setCompanyName] = useState("");
  const [CompanyAddress, setCompanyAddress] = useState("");
  const [CompanyMobile, setCompanyMobile] = useState("");
  const [CompanyEmail, setCompanyEmail] = useState("");
  const [CompanyWebsite, setCompanyWebsite] = useState("");
  const [homeMsg, setHomeMsg] = useState("");
  const [depositMsg, setDepositMsg] = useState("");
  const [withdrawMsg, setWithdrawMsg] = useState("");
  const [gameMsg, setGameMsg] = useState("");
  const [whatsapp_number, setWhatsappNumber] = useState("");
  const [ReferralURL, setReferralURL] = useState("");
  const [PWAName, setPWAName] = useState("");
  const [AppDownloadLink, setAppDownloadLink] = useState("");

  const [telegram_link, setTelegramLink] = useState("");
  const [InstagramLink, setInstagramLink] = useState(""); // New
  const [phone_number, setPhoneNumber] = useState("");
  const [min_deposit, setMinDeposit] = useState("");
  const [max_deposit, setMaxDeposit] = useState("");
  const [min_withdrawal, setMinWithdrawal] = useState("");
  const [max_withdrawal, setMaxWithdrawal] = useState("");
  const [withdrawal_cooldown, setWithdrawalCooldown] = useState(0); // New
  const [withdraw_start_time, setWithdrawStartTime] = useState("");
  const [withdraw_end_time, setWithdrawEndTime] = useState("");
  const [Logo, setLogo] = useState("");
  const [SmallLogo, setSmallLogo] = useState("");
  const [PWALogo, setPwaLogo] = useState("");
  const [LandingImage1, setLandingImage1] = useState("");
  const [LandingImage2, setLandingImage2] = useState("");
  const [LandingImage3, setLandingImage3] = useState("");
  const [LandingImage4, setLandingImage4] = useState("");
  const [ServiceBanner, setServiceBanner] = useState("");
  const [isLandingImage1, issetLandingImage1] = useState(true);
  const [isLandingImage2, issetLandingImage2] = useState(true);
  const [isLandingImage3, issetLandingImage3] = useState(true);
  const [isLandingImage4, issetLandingImage4] = useState(true);
  const [version, setVersion] = useState("");
  const [settingId, setSettingId] = useState("");
  const [Commission, setCommission] = useState([]);
  const [signup_bonus, setSignupBonus] = useState(0);
  const [MaintenanceMode, setMaintenanceMode] = useState(false);
  const [MaintenanceMsg, setMaintenanceMsg] = useState("");
  const [FakeGame, setFakeGame] = useState(false);
  const [FakeRunningGame, setFakeRunningGame] = useState(false);
  const [game_delete_time, setGameDeleteTime] = useState(1);
  const [referral_commission, setReferralCommission] = useState(2);
  const [admin_override_wait_minutes, setAdminOverrideWaitMinutes] = useState(10);
  const [isSettingsLoaded, setIsSettingsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(false);

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  var baseUrl = nodeMode === "development" ? beckendLocalApiUrl : beckendLiveApiUrl;

  if (baseUrl) {
    baseUrl = baseUrl.replace(/\/+$/, "") + "/";
  }

  // --- FETCH DATA (UNCHANGED) ---
  useEffect(() => {
    axios.get(baseUrl + "settings/data", {}).then((res) => {
      setSettingId((res.data._id) ? res.data._id : '');
      setWebTitle(res.data.WebTitle || "");
      setWebName(res.data.WebsiteName || "");
      setCompanyName(res.data.CompanyName || "");
      setCompanyAddress(res.data.CompanyAddress || "");
      setCompanyMobile(res.data.CompanyMobile || "");
      setCompanyEmail(res.data.CompanyEmail || "");
      setCompanyWebsite(res.data.CompanyWebsite || "");
      setHomeMsg(res.data.homeMsg || "");
      setGameMsg(res.data.gameMsg || "");
      setWithdrawMsg(res.data.withdrawMsg || "");
      setDepositMsg(res.data.depositMsg || "");
      setWhatsappNumber(res.data.whatsapp_number || "");
      setTelegramLink(res.data.telegram_link || "");
      setInstagramLink(res.data.InstagramLink || ""); // New
      setPhoneNumber(res.data.phone_number || "");
      setMinDeposit(res.data.min_deposit || "");
      setMaxDeposit(res.data.max_deposit || "");
      setMinWithdrawal(res.data.min_withdrawal || "");
      setMaxWithdrawal(res.data.max_withdrawal || "");
      setWithdrawalCooldown(res.data.withdrawal_cooldown || 0); // New
      setWithdrawStartTime(res.data.withdraw_start_time || "00:00");
      setWithdrawEndTime(res.data.withdraw_end_time || "23:59");
      setVersion(res.data.version || "");
      issetLandingImage1(res.data.isLandingImage1);
      issetLandingImage2(res.data.isLandingImage2);
      issetLandingImage3(res.data.isLandingImage3);
      issetLandingImage4(res.data.isLandingImage4);
      setCommission(res.data.Commission || []);
      setSignupBonus(res.data.signup_bonus || 0);
      setMaintenanceMode(res.data.MaintenanceMode || false);
      setMaintenanceMsg(res.data.MaintenanceMsg || "");
      setFakeGame(res.data.FakeGame || false);
      setFakeRunningGame(res.data.FakeRunningGame || false);
      setReferralURL(res.data.ReferralURL || "");
      setPWAName(res.data.PWAName || "");
      setAppDownloadLink(res.data.AppDownloadLink || "");
      setGameDeleteTime(res.data.game_delete_time || 1);
      setReferralCommission(res.data.referral_commission || 2);
      setAdminOverrideWaitMinutes(res.data.admin_override_wait_minutes || 10);
      setIsSettingsLoaded(true);
    }).catch((error) => {
      console.error("Failed to load current settings:", error);
      setLoadError(true);
    });
  }, [baseUrl]);

  // --- SUBMIT DATA ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isSettingsLoaded) {
      // Guards against the race condition that caused 22 duplicate settings
      // documents (see CHANGELOG): submitting before the current settingId
      // has loaded meant the backend created a brand new document instead
      // of updating the existing one.
      alert("Settings are still loading. Please wait a moment and try again.");
      return;
    }
    let formData = new FormData();
    formData.append("settingId", settingId);
    formData.append("WebTitle", WebTitle);
    formData.append("WebsiteName", WebsiteName);
    formData.append("CompanyName", CompanyName);
    formData.append("CompanyAddress", CompanyAddress);
    formData.append("CompanyMobile", CompanyMobile);
    formData.append("CompanyEmail", CompanyEmail);
    formData.append("CompanyWebsite", CompanyWebsite);
    formData.append("homeMsg", homeMsg);
    formData.append("depositMsg", depositMsg);
    formData.append("withdrawMsg", withdrawMsg);
    formData.append("gameMsg", gameMsg);
    formData.append("whatsapp_number", whatsapp_number);
    formData.append("telegram_link", telegram_link);
    formData.append("InstagramLink", InstagramLink); // New
    formData.append("phone_number", phone_number);
    formData.append("min_deposit", min_deposit);
    formData.append("max_deposit", max_deposit);
    formData.append("min_withdrawal", min_withdrawal);
    formData.append("max_withdrawal", max_withdrawal);
    formData.append("withdrawal_cooldown", withdrawal_cooldown); // New
    formData.append("withdraw_start_time", withdraw_start_time);
    formData.append("withdraw_end_time", withdraw_end_time);
    formData.append("Logo", Logo);
    formData.append("SmallLogo", SmallLogo);
    formData.append("PWALogo", PWALogo);
    formData.append("LandingImage1", LandingImage1);
    formData.append("LandingImage2", LandingImage2);
    formData.append("LandingImage3", LandingImage3);
    formData.append("LandingImage4", LandingImage4);
    formData.append("ServiceBanner", ServiceBanner);
    formData.append("isLandingImage1", isLandingImage1);
    formData.append("isLandingImage2", isLandingImage2);
    formData.append("isLandingImage3", isLandingImage3);
    formData.append("isLandingImage4", isLandingImage4);
    formData.append("version", version);
    formData.append("signup_bonus", signup_bonus);
    formData.append("MaintenanceMode", MaintenanceMode);
    formData.append("MaintenanceMsg", MaintenanceMsg);
    formData.append("FakeGame", FakeGame);
    formData.append("FakeRunningGame", FakeRunningGame);
    formData.append("ReferralURL", ReferralURL);
    formData.append("PWAName", PWAName);
    formData.append("AppDownloadLink", AppDownloadLink);
    formData.append("game_delete_time", game_delete_time);
    formData.append("referral_commission", referral_commission);
    formData.append("admin_override_wait_minutes", admin_override_wait_minutes);
    formData.append("Commission", JSON.stringify(Commission));

    try {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      console.log("Submitting to:", baseUrl + `settings`);
      const response = await axios.post(baseUrl + `settings`, formData, { headers });
      if (response.data.status === 'success') {
        alert("Settings submitted successfully");
        window.location.reload();
      } else {
        alert("Settings Not Submitted: " + (response.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Submission Error:", error);
      const errorMsg = error.response?.data?.message || error.message || "Network Error";
      alert("Error submitting data: " + errorMsg);
    }
  };

  // --- FILE HANDLERS (UNCHANGED) ---
  // --- FILE HANDLERS REMOVED (Replaced by direct onChange) ---

  // --- COMMISSION HANDLERS ---
  const handleCommissionChange = (index, field, value) => {
    const newCommission = [...Commission];
    newCommission[index][field] = value;
    setCommission(newCommission);
  };

  const addCommissionRow = () => {
    setCommission([...Commission, { min_amount: 0, max_amount: 0, percentage: 0 }]);
  };

  const removeCommissionRow = (index) => {
    const newCommission = Commission.filter((_, i) => i !== index);
    setCommission(newCommission);
  };

  return (
    <div className="settings-page-container p-4">
      <style>{`
        .settings-page-container { background: #f0f2f5; min-height: 100vh; font-family: 'Poppins', sans-serif; }
        .settings-header { background: #fff; padding: 25px; border-radius: 20px; box-shadow: 0 5px 15px rgba(0,0,0,0.05); margin-bottom: 30px; }
        
        .settings-card { 
            background: #ffffff; border-radius: 25px; overflow: hidden; 
            box-shadow: 0 10px 30px rgba(0,0,0,0.08); margin-bottom: 35px;
            border: 1px solid #edf2f7;
        }
        .card-banner-purple { background: linear-gradient(45deg, #57155a, #8e44ad); color: white; padding: 15px 25px; font-weight: 700; font-size: 1.1rem; }
        .card-banner-green { background: linear-gradient(45deg, #27ae60, #2ecc71); color: white; padding: 15px 25px; font-weight: 700; font-size: 1.1rem; }
        .card-banner-blue { background: linear-gradient(45deg, #2980b9, #3498db); color: white; padding: 15px 25px; font-weight: 700; font-size: 1.1rem; }
        
        .form-body { padding: 30px; }
        .label-custom { font-weight: 700; color: #57155a; margin-bottom: 8px; font-size: 0.85rem; text-transform: uppercase; letter-spacing: 0.5px; }
        
        .input-modern { 
            border: 2px solid #edf2f7; border-radius: 12px; padding: 10px 15px; 
            font-weight: 600; color: #2d3436; transition: 0.3s; background: #f8faff;
        }
        .input-modern:focus { border-color: #57155a; background: #fff; box-shadow: none; }
        
        .save-settings-btn { 
            background: linear-gradient(45deg, #57155a, #3a0d3c); color: white; 
            border: none; padding: 15px 40px; border-radius: 15px; 
            font-weight: 800; text-transform: uppercase; letter-spacing: 1px;
            width: 100%; transition: 0.4s; cursor: pointer;
        }
        .save-settings-btn:hover { transform: translateY(-3px); box-shadow: 0 10px 25px rgba(87, 21, 90, 0.3); }
        
        .file-upload-box { border: 2px dashed #cbd5e0; border-radius: 12px; padding: 10px; background: #fff; }
      `}</style>

      <div className="settings-header">
        <h2 style={{ fontWeight: 900, color: '#2d3436', margin: 0 }}>Website <span style={{ color: '#57155a' }}>Config</span></h2>
        <p className="text-muted m-0">Global settings for user interface and support</p>
      </div>

      <form onSubmit={handleSubmit} encType="multipart/form-data">

        {/* SECTION 1: SUPPORT & SOCIAL */}
        <div className="settings-card">
          <div className="card-banner-purple">🛡️ Support & Social Integration</div>
          <div className="form-body row">
            <div className="form-group col-md-4">
              <label className="label-custom">WhatsApp (Country Code Only)</label>
              <input className="form-control input-modern" type="text" value={whatsapp_number} onChange={(e) => setWhatsappNumber(e.target.value)} placeholder="Ex: 917253907566" />
            </div>
            <div className="form-group col-md-4">
              <label className="label-custom">Telegram Link</label>
              <label className="label-custom">Telegram Link</label>
              <input className="form-control input-modern" type="text" value={telegram_link} onChange={(e) => setTelegramLink(e.target.value)} placeholder="https://t.me/..." />
            </div>
            <div className="form-group col-md-4">
              <label className="label-custom">Instagram Link</label>
              <input className="form-control input-modern" type="text" value={InstagramLink} onChange={(e) => setInstagramLink(e.target.value)} placeholder="https://instagram.com/..." />
            </div>
            <div className="form-group col-md-4">
              <label className="label-custom">Direct Call Support</label>
              <input className="form-control input-modern" type="text" value={phone_number} onChange={(e) => setPhoneNumber(e.target.value)} placeholder="Calling number" />
            </div>
          </div>
        </div>

        {/* SECTION 2: GENERAL INFO */}
        <div className="settings-card">
          <div className="card-banner-blue">🏠 General Information</div>
          <div className="form-body row">
            <div className="form-group col-md-6">
              <label className="label-custom">Website Meta Title</label>
              <input className="form-control input-modern" type="text" value={WebTitle} onChange={(e) => setWebTitle(e.target.value)} />
            </div>
            <div className="form-group col-md-6">
              <label className="label-custom">Website Brand Name</label>
              <input className="form-control input-modern" type="text" value={WebsiteName} onChange={(e) => setWebName(e.target.value)} />
            </div>
            <div className="form-group col-md-4 mt-3">
              <label className="label-custom">Official Email</label>
              <input className="form-control input-modern" type="text" value={CompanyEmail} onChange={(e) => setCompanyEmail(e.target.value)} />
            </div>
            <div className="form-group col-md-4 mt-3">
              <label className="label-custom">App Version</label>
              <input className="form-control input-modern" type="text" value={version} onChange={(e) => setVersion(e.target.value)} />
            </div>
            <div className="form-group col-md-4 mt-3">
              <label className="label-custom">Official Mobile</label>
              <input className="form-control input-modern" type="text" value={CompanyMobile} onChange={(e) => setCompanyMobile(e.target.value)} />
            </div>
            <div className="form-group col-md-4 mt-3">
              <label className="label-custom">Referral URL (Link)</label>
              <input className="form-control input-modern" type="text" value={ReferralURL} onChange={(e) => setReferralURL(e.target.value)} placeholder="https://unitedludoclub.com/login/" />
              <small className="text-muted">Users code will be appended to this link</small>
            </div>
            <div className="form-group col-md-4 mt-3">
              <label className="label-custom">PWA / App Install Name</label>
              <input className="form-control input-modern" type="text" value={PWAName} onChange={(e) => setPWAName(e.target.value)} placeholder="SR Players App" />
            </div>
            <div className="form-group col-md-4 mt-3">
              <label className="label-custom">Direct App Download Link (APK URL)</label>
              <input className="form-control input-modern" type="text" value={AppDownloadLink} onChange={(e) => setAppDownloadLink(e.target.value)} placeholder="https://yoursite.com/app.apk" />
            </div>
            <div className="form-group col-md-4 mt-3">
              <label className="label-custom">PWA / App Logo</label>
              <div className="file-upload-box" style={{padding: '5px 10px'}}><input type="file" onChange={(e) => setPwaLogo(e.target.files[0])} className="w-100" /></div>
              <small className="text-muted">Used for Download App icon</small>
            </div>
          </div>
        </div>

        {/* SECTION 3: MESSAGES */}
        <div className="settings-card">
          <div className="card-banner-purple">📢 Global Notification Messages</div>
          <div className="form-body row">
            <div className="form-group col-md-6">
              <label className="label-custom">Home Screen Message</label>
              <textarea className="form-control input-modern" rows="2" value={homeMsg} onChange={(e) => setHomeMsg(e.target.value)}></textarea>
            </div>
            <div className="form-group col-md-6">
              <label className="label-custom">Game Rules/Battle Msg</label>
              <textarea className="form-control input-modern" rows="2" value={gameMsg} onChange={(e) => setGameMsg(e.target.value)}></textarea>
            </div>
            <div className="form-group col-md-6 mt-3">
              <label className="label-custom">Deposit Screen Alert</label>
              <textarea className="form-control input-modern" rows="2" value={depositMsg} onChange={(e) => setDepositMsg(e.target.value)}></textarea>
            </div>
            <div className="form-group col-md-6 mt-3">
              <label className="label-custom">Withdrawal Screen Alert</label>
              <textarea className="form-control input-modern" rows="2" value={withdrawMsg} onChange={(e) => setWithdrawMsg(e.target.value)}></textarea>
            </div>
          </div>
        </div>

        {/* SECTION 4: LIMITS */}
        <div className="settings-card">
          <div className="card-banner-green">💰 Transaction Limits (INR)</div>
          <div className="form-body row">
            <div className="form-group col-md-3">
              <label className="label-custom">Min Deposit</label>
              <input className="form-control input-modern" type="number" value={min_deposit} onChange={(e) => setMinDeposit(e.target.value)} />
            </div>
            <div className="form-group col-md-3">
              <label className="label-custom">Max Deposit</label>
              <input className="form-control input-modern" type="number" value={max_deposit} onChange={(e) => setMaxDeposit(e.target.value)} />
            </div>
            <div className="form-group col-md-3">
              <label className="label-custom">Min Withdraw</label>
              <input className="form-control input-modern" type="number" value={min_withdrawal} onChange={(e) => setMinWithdrawal(e.target.value)} />
            </div>
            <div className="form-group col-md-3">
              <label className="label-custom">Max Withdraw</label>
              <input className="form-control input-modern" type="number" value={max_withdrawal} onChange={(e) => setMaxWithdrawal(e.target.value)} />
            </div>
            <div className="form-group col-md-3">
              <label className="label-custom">Cooldown (Minutes)</label>
              <input className="form-control input-modern" type="number" value={withdrawal_cooldown} onChange={(e) => setWithdrawalCooldown(e.target.value)} placeholder="0" />
            </div>
            <div className="form-group col-md-3">
              <label className="label-custom">Withdraw Start Time</label>
              <input className="form-control input-modern" type="time" value={withdraw_start_time} onChange={(e) => setWithdrawStartTime(e.target.value)} />
            </div>
            <div className="form-group col-md-3">
              <label className="label-custom">Withdraw End Time</label>
              <input className="form-control input-modern" type="time" value={withdraw_end_time} onChange={(e) => setWithdrawEndTime(e.target.value)} />
            </div>
          </div>
        </div>

        {/* SECTION 4.5: SIGNUP BONUS & MAINTENANCE */}
        <div className="settings-card">
          <div className="card-banner-purple">🎁 Bonus & 🔧 Maintenance</div>
          <div className="form-body row">
            <div className="form-group col-md-4">
              <label className="label-custom">Signup Bonus Amount (₹)</label>
              <input
                className="form-control input-modern"
                type="number"
                value={signup_bonus}
                onChange={(e) => setSignupBonus(e.target.value)}
                placeholder="0"
              />
            </div>
            <div className="form-group col-md-4">
              <label className="label-custom">Referral Commission (%)</label>
              <input
                className="form-control input-modern"
                type="number"
                value={referral_commission}
                onChange={(e) => setReferralCommission(e.target.value)}
                placeholder="2"
              />
            </div>
            <div className="form-group col-md-4">
              <label className="label-custom">Game Auto-Delete (Minutes)</label>
              <input
                className="form-control input-modern"
                type="number"
                value={game_delete_time}
                onChange={(e) => setGameDeleteTime(e.target.value)}
                placeholder="1"
              />
            </div>
            <div className="form-group col-md-4">
              <label className="label-custom">Admin Override Wait (Minutes)</label>
              <input
                className="form-control input-modern"
                type="number"
                value={admin_override_wait_minutes}
                onChange={(e) => setAdminOverrideWaitMinutes(e.target.value)}
                placeholder="10"
              />
            </div>
            <div className="form-group col-md-4 mt-3">
              <label className="label-custom">Maintenance Mode</label>
              <select
                className="form-control input-modern"
                value={MaintenanceMode}
                onChange={(e) => setMaintenanceMode(e.target.value === "true")}
              >
                <option value="false">🟢 Live (Active)</option>
                <option value="true">🔴 Maintenance (Closed)</option>
              </select>
            </div>
            <div className="form-group col-md-4">
              <label className="label-custom">Fake Open Games</label>
              <select
                className="form-control input-modern"
                value={FakeGame}
                onChange={(e) => setFakeGame(e.target.value === "true")}
              >
                <option value="false">❌ OFF</option>
                <option value="true">✅ ON (Run 5 Open Fake Games)</option>
              </select>
            </div>
            <div className="form-group col-md-4">
              <label className="label-custom">Fake Running Games</label>
              <select
                className="form-control input-modern"
                value={FakeRunningGame}
                onChange={(e) => setFakeRunningGame(e.target.value === "true")}
              >
                <option value="false">❌ OFF</option>
                <option value="true">✅ ON (Run 20 Running Games)</option>
              </select>
            </div>
            <div className="form-group col-md-12 mt-3">
              <label className="label-custom">Maintenance Message</label>
              <textarea
                className="form-control input-modern"
                rows="2"
                value={MaintenanceMsg}
                onChange={(e) => setMaintenanceMsg(e.target.value)}
                placeholder="We are currently under maintenance. Please check back later."
              ></textarea>
            </div>
          </div>
        </div>

        {/* SECTION 5: MEDIA */}
        <div className="settings-card">
          <div className="card-banner-blue">🖼️ Brand Media & Banners</div>
          <div className="form-body">
            <div className="row mb-4">
              <div className="col-md-6">
                <label className="label-custom">Header Main Logo</label>
                <div className="file-upload-box"><input type="file" onChange={(e) => setLogo(e.target.files[0])} className="w-100" /></div>
              </div>
              <div className="col-md-6">
                <label className="label-custom">Favicon / Small Logo</label>
                <div className="file-upload-box"><input type="file" onChange={(e) => setSmallLogo(e.target.files[0])} className="w-100" /></div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-12">
                <label className="label-custom">Main Service Banner (Bottom of Landing)</label>
                <div className="file-upload-box"><input type="file" onChange={(e) => setServiceBanner(e.target.files[0])} className="w-100" /></div>
              </div>
            </div>
            <label className="label-custom">Landing/Game Banners & Controls</label>
            <div className="row mt-2">
              {[1, 2, 3, 4].map((num) => {
                const landingStates = {
                  1: { val: isLandingImage1, set: issetLandingImage1 },
                  2: { val: isLandingImage2, set: issetLandingImage2 },
                  3: { val: isLandingImage3, set: issetLandingImage3 },
                  4: { val: isLandingImage4, set: issetLandingImage4 },
                };
                return (
                  <div key={num} className="col-md-3 mb-3">
                    <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '15px', border: '1px solid #eee' }}>
                      <span style={{ fontSize: '0.7rem', fontWeight: 800, color: '#57155a' }}>BANNER {num}</span>
                      <input 
                        type="file" 
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (num === 1) setLandingImage1(file);
                          if (num === 2) setLandingImage2(file);
                          if (num === 3) setLandingImage3(file);
                          if (num === 4) setLandingImage4(file);
                        }} 
                        className="mt-2 w-100 mb-2" 
                        style={{ fontSize: '0.6rem' }} 
                      />
                      <select
                        className="form-control modern-input"
                        style={{ fontSize: '0.8rem', height: '35px', padding: '0 10px' }}
                        value={landingStates[num]?.val}
                        onChange={(e) => landingStates[num]?.set(e.target.value === "true")}
                      >
                        <option value="true">✅ ACTIVE</option>
                        <option value="false">❌ HIDDEN</option>
                      </select>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        {/* SECTION 6: COMMISSION SETTINGS */}
        <div className="settings-card">
          <div className="card-banner-purple">💸 Game Commission Structure</div>
          <div className="form-body">
            <div className="alert alert-info">
              Define the commission percentage for different game amount ranges.
              <br />Example: 50 to 250 = 5%
            </div>
            {Commission && Commission.map((item, index) => (
              <div key={index} className="row mb-2 align-items-end">
                <div className="col-md-3">
                  <label className="label-custom">Min Amount</label>
                  <input
                    type="number"
                    className="form-control input-modern"
                    value={item.min_amount}
                    onChange={(e) => handleCommissionChange(index, 'min_amount', e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label className="label-custom">Max Amount</label>
                  <input
                    type="number"
                    className="form-control input-modern"
                    value={item.max_amount}
                    onChange={(e) => handleCommissionChange(index, 'max_amount', e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label className="label-custom">Commission (%)</label>
                  <input
                    type="number"
                    className="form-control input-modern"
                    value={item.percentage}
                    onChange={(e) => handleCommissionChange(index, 'percentage', e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <button
                    type="button"
                    className="btn btn-danger w-100"
                    style={{ borderRadius: '12px', fontWeight: 'bold' }}
                    onClick={() => removeCommissionRow(index)}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
            <button
              type="button"
              className="btn btn-success mt-3"
              style={{ borderRadius: '12px', fontWeight: 'bold' }}
              onClick={addCommissionRow}
            >
              + Add New Commission Range
            </button>
          </div>
        </div>

        {loadError && (
          <div className="alert alert-danger" style={{ borderRadius: '12px', fontWeight: 'bold' }}>
            Could not load current settings. Saving is disabled until this page is reloaded successfully - submitting now would create a duplicate settings document.
          </div>
        )}
        <button
          type="submit"
          className="save-settings-btn animate__animated animate__pulse animate__infinite"
          disabled={!isSettingsLoaded}
          style={!isSettingsLoaded ? { opacity: 0.6, cursor: 'not-allowed' } : undefined}
        >
          {isSettingsLoaded ? '💾 Update System Settings' : 'Loading current settings…'}
        </button>
      </form>

      <div className="mt-5 mb-5 p-4" style={{ background: '#fff', borderRadius: '25px', boxShadow: '0 10px 30px rgba(0,0,0,0.05)' }}>
        <h5 className="label-custom mb-4" style={{ fontSize: '1rem' }}>Payment Gateway Integration</h5>
        <Gateway />
      </div>
    </div>
  );
};

export default Sitesettings;
